import { useContext } from 'react';

import { IntakeSummaryExperimentContext } from './IntakeSummaryExperimentContext';

export function useIntakeSummaryExperiment() {
  return useContext(IntakeSummaryExperimentContext);
}
